(function () {
  function urlHasVariantParam() {
    return new URLSearchParams(window.location.search).has('variant');
  }

  function getCurrentVariantIdFromForm() {
    // Most Shopify product forms have an input/select named "id" containing the variant id
    var idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (!idInput) return null;
    return idInput.value || null;
  }

  function ensureVariantParamInUrl() {
    if (urlHasVariantParam()) return false;

    var variantId = getCurrentVariantIdFromForm();
    if (!variantId) return false;

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    history.replaceState({}, '', url.toString());

    // Trigger your existing URL-change handlers
    window.dispatchEvent(new Event('locationchange'));
    return true;
  }

  function getSelectedOption1() {
    var checked = document.querySelector(
      'input.product-form__single-selector[type="radio"][data-option-position="1"]:checked'
    );
    return checked ? checked.value : null;
  }

  // Highlight targets can be either row-level spans or block-level wrappers
  function getHighlightTargetsSelector() {
    return '.variant-row[data-option1], .variant-block[data-option1]';
  }

  function clearHighlights() {
    document.querySelectorAll(getHighlightTargetsSelector()).forEach(function (el) {
      el.classList.remove('is-active');
    });
  }

  function applyHighlight(option1Value) {
    clearHighlights();
    if (!option1Value) return;

    var selector =
      '.variant-row[data-option1="' + CSS.escape(option1Value) + '"], ' +
      '.variant-block[data-option1="' + CSS.escape(option1Value) + '"]';

    document.querySelectorAll(selector).forEach(function (el) {
      el.classList.add('is-active');
    });
  }

  function runBasedOnUrl() {
    if (!urlHasVariantParam()) {
      clearHighlights();
      return;
    }
    applyHighlight(getSelectedOption1());
  }

  // ---- URL change detection ----
  function triggerLocationChange() {
    window.dispatchEvent(new Event('locationchange'));
  }

  ['pushState', 'replaceState'].forEach(function (method) {
    var original = history[method];
    history[method] = function () {
      var result = original.apply(this, arguments);
      triggerLocationChange();
      return result;
    };
  });

  window.addEventListener('popstate', triggerLocationChange);
  window.addEventListener('locationchange', runBasedOnUrl);

  // Initial load: do NOT highlight unless URL already has ?variant=
  document.addEventListener('DOMContentLoaded', runBasedOnUrl);

  // Listen to CLICK so clicking the already-selected option still counts
  document.addEventListener('click', function (e) {
    var swatchClicked = e.target.closest('.block-swatch__item, .block-swatch__radio');
    if (!swatchClicked) return;

    // If this is the first interaction and there is no ?variant=, add it
    ensureVariantParamInUrl();

    // Give the theme a moment to update the underlying [name="id"] if needed
    setTimeout(runBasedOnUrl, 0);
  });

  // Keep change listener too (covers keyboard / accessibility changes cleanly)
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (
      t &&
      t.matches &&
      t.matches('input.product-form__single-selector[type="radio"][data-option-position="1"]')
    ) {
      setTimeout(runBasedOnUrl, 0);
    }
  });
})();
